export const isLiveStreamStartAllowed = (eventStartTime: string | null): boolean => {
  if (!eventStartTime) {
    return false;
  }
  const startTime = new Date(eventStartTime).getTime();
  const currentTime = Date.now();
  const timeDifference = startTime - currentTime;

  // Allow starting the livestream if within 30 minutes before or any time after the event start time
  return timeDifference <= 30 * 60 * 1000;
};
